export const countryCode = '1001';

export const businessCategory = [
  {
    value: 'Airport Outlets',
    label: 'Airport',
    subCategory: [
      {
        value: 'Airport Outlets_TRANSPORTATION SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Airlines and Air Carriers (Not Elsewhere Classified)',
            label: 'Airlines & Air Carriers',
          },
          {
            required: true,
            value: 'Airports, Flying Fields, and Airport Terminals',
            label: 'Airport Outlets , Flying Fields & Airport Terminals',
          },
          {
            required: false,
            value: 'Airports, Flying Fields, Airport Terminals_4813',
            label: 'Airports, Flying Fields, Airport Terminals_4813',
          },
        ],
      },
    ],
  },
  {
    value: 'Apparels',
    label: 'Apparels',
    subCategory: [
      {
        value: 'Apparels_CLOTHING STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Tailors, Seamstresses, Mending, and Alterations',
            label: 'Tailors, Seamstresses, Mending & Alterations',
          },
          {
            required: true,
            value: 'Women’s Ready-To-Wear Stores',
            label: 'Women’s Ready-To-Wear Stores',
          },
          {
            required: true,
            value:
              'Men’s, Women’s, and Children’s Uniforms and Commercial Clothing',
            label: 'Uniforms & Commercial Clothing Stores',
          },
          {
            required: true,
            value: 'Family Clothing Stores',
            label: 'Family Clothing Stores',
          },
          {
            required: true,
            value: 'Furriers and Fur Shops',
            label: 'Furriers and Fur Shops',
          },
          {
            required: true,
            value: 'Men’s and Women’s Clothing Stores',
            label: 'Men’s and Women’s Clothing Stores',
          },
          {
            required: true,
            value: 'Children’s and Infant’s Wear Stores',
            label: 'Children’s and Infant’s Wear Stores',
          },
        ],
      },
      {
        value: 'Apparels_PERSONAL SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: false,
            value: 'Apparels_PERSONAL SERVICE PROVIDERS',
            label: 'Apparels_PERSONAL SERVICE PROVIDERS',
          },
        ],
      },
      {
        value: 'Apparels_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: false,
            value:
              'Men’s, Women’s, and Children’s Uniforms and Commercial Clothing',
            label:
              'Men’s, Women’s, and Children’s Uniforms and Commercial Clothing',
          },
        ],
      },
    ],
  },
  {
    value: 'Automobiles',
    label: 'Automobiles',
    subCategory: [
      {
        value: 'Automobiles_AUTOMOBILE/VEHICLE RENTALS',
        merchantCategory: [
          {
            required: true,
            value: 'Motor Home and Recreational Vehicle Rentals',
            label: 'Motor Home & Recreational Vehicle Rentals',
          },
          {
            required: true,
            value: 'Truck and Utility Trailer Rentals',
            label: 'Truck & Utility Trailer Rentals',
          },
        ],
      },
      {
        value: 'Automobiles_AUTOMOBILES AND VEHICLES',
        merchantCategory: [
          {
            required: true,
            value:
              'Car and Truck Dealers (Used Only) Sales, Service, Repairs, Parts, and Leasing',
            label:
              'Car & Truck Dealers (Only Used) - Sales, Service &  Repairs',
          },
          {
            required: true,
            value:
              'Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts, and Leasing',
            label:
              'Car & Truck Dealers (New and Used) - Sales, Service &  Repairs',
          },
          {
            required: true,
            value: 'Automotive Parts and Accessories Stores',
            label: 'Automotive Parts and Accessories Stores',
          },
          {
            required: true,
            value: 'Automotive Tire Stores',
            label: 'Automotive Tyre Stores',
          },
          {
            required: true,
            value: 'Boat Dealers',
            label: 'Boat Dealers & Marine Products',
          },
          {
            required: true,
            value:
              'Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers (Not Elsewhere Classified)',
            label: 'Automotive, Aircraft & Farm Equipment Dealers',
          },
          {
            required: true,
            value: 'Motorcycle Shops and Dealers',
            label: 'Motorcycle Shops & Dealers',
          },
          {
            required: true,
            value: 'Motor Homes Dealers',
            label: 'Motor Homes Dealers',
          },
          {
            required: true,
            value: 'Camper, Recreational and Utility Trailer Dealers',
            label: 'Camp, Tent & Awning Shops',
          },
          {
            required: true,
            value: 'Snowmobile Dealers',
            label: 'Snowmobile Dealers',
          },
        ],
      },
      {
        value: 'Automobiles_BUSINESS SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Parking Lots, Parking Meters and Garages',
            label: 'Parking Lots & Garages',
          },
        ],
      },
      {
        value: 'Automobiles_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value: 'Automobile Associations',
            label: 'Automobile Associations',
          },
        ],
      },
      {
        value: 'Automobiles_REPAIR SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Automotive Service Shops (Non-Dealer)',
            label: 'Automotive Service Shops',
          },
          {
            required: true,
            value: 'Automotive Body Repair Shops',
            label: 'Automotive Body Repair Shops',
          },
          {
            required: true,
            value: 'Automotive Paint Shops',
            label: 'Automotive Paint Shops',
          },
          {
            required: true,
            value: 'Car Washes',
            label: 'Car Wash',
          },
        ],
      },
      {
        value: 'Automobiles_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Motor Vehicle Supplies and New Parts',
            label: 'Motor Vehicle Supplies & New Parts',
          },
        ],
      },
    ],
  },
  {
    value: 'Bags And Luggage',
    label: 'Bags & Luggage',
    subCategory: [
      {
        value: 'Bags And Luggage_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Luggage and Leather Goods Stores',
            label: 'Luggage & Leather Goods Stores',
          },
        ],
      },
    ],
  },
  {
    value: 'Beauty & Wellness',
    label: 'Beauty & Wellness',
    subCategory: [
      {
        value: 'Beauty & Wellness_Beauty And Wellness',
        merchantCategory: [
          {
            required: true,
            value: 'Beauty and Barber Shops',
            label: 'Beauty & Barber Shops',
          },
          {
            required: true,
            value: 'Cosmetic Stores',
            label: 'Cosmetic & Perfume Stores',
          },
        ],
      },
      {
        value: 'Beauty & Wellness_PERSONAL SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Health and Beauty Spas',
            label: 'Health & Beauty Spas',
          },
          {
            required: true,
            value: 'Massage Parlors',
            label: 'Massage Parlors',
          },
        ],
      },
    ],
  },
  {
    value: 'Books And Media',
    label: 'Books & Media',
    subCategory: [
      {
        value: 'Books And Media_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Digital Goods Media - Books, Movies, Music',
            label: 'Digital Goods Media - Books , Movies & Music',
          },
        ],
      },
      {
        value: 'Books And Media_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Books, Periodicals and Newspapers',
            label: 'Books, Periodicals &  Newspapers',
          },
        ],
      },
    ],
  },
  {
    value: 'Cabs',
    label: 'Cabs',
    subCategory: [
      {
        value: 'Cabs _TRANSPORTATION SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Taxicabs and Limousines',
            label: 'Cab & Taxi',
          },
        ],
      },
    ],
  },
  {
    value: 'Car Rentals',
    label: 'Car Rental',
    subCategory: [
      {
        value: 'CAR RENTAL AGENCIES',
        merchantCategory: [
          {
            required: true,
            value: 'AFFILIATED AUTO RENTAL',
            label: 'Auto Rental',
          },
        ],
      },
      {
        value: 'Car Rentals_AUTOMOBILE/VEHICLE RENTALS',
        merchantCategory: [
          {
            required: true,
            value: 'Automobile Rental Agency',
            label: 'Automobile Rental Agency',
          },
        ],
      },
    ],
  },
  {
    value: 'Chemist',
    label: 'Chemist',
    subCategory: [
      {
        value: 'Chemist_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Drug Stores and Pharmacies',
            label: 'Chemist Shops & Pharmacies',
          },
          {
            required: true,
            value: 'Orthopedic Goods – Prosthetic Devices',
            label: 'Orthopedic Goods & Prosthetic Devices',
          },
        ],
      },
      {
        value: 'Chemist_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Drugs, Drug Proprietaries, and Druggist Sundries',
            label: 'Drugs, Drug Proprietaries & Druggist Sundries',
          },
        ],
      },
    ],
  },
  {
    value: 'Cinemas',
    label: 'Cinemas',
    subCategory: [
      {
        value: 'Cinemas_AMUSEMENT AND ENTERTAINMENT',
        merchantCategory: [
          {
            required: false,
            value: 'Motion Picture Theaters',
            label: 'Motion Picture Theaters',
          },
          {
            required: true,
            value:
              'Ticket Agencies and Theatrical Producers (Except Motion Pictures)',
            label: 'Cinema , Theatres & Ticket Agencies',
          },
        ],
      },
    ],
  },
  {
    value: 'Dinning',
    label: 'Dinning',
    subCategory: [
      {
        value: 'Dinning_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Bakeries',
            label: 'Bakeries',
          },
          {
            required: true,
            value: 'Caterers',
            label: 'Caterers',
          },
          {
            required: true,
            value: 'Eating Places and Restaurants',
            label: 'Restaurants, Café & Eating Places',
          },
        ],
      },
    ],
  },
  {
    value: 'Doctors',
    label: 'Doctors',
    subCategory: [
      {
        value: 'Doctors_AGRICULTURAL SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Veterinary Services',
            label: 'Veterinary Services',
          },
        ],
      },
      {
        value: 'Doctors_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value: 'Podiatrists and Chiropodists',
            label: 'Podiatrists & Chiropodists',
          },
          {
            required: true,
            value: 'Chiropractors',
            label: 'Chiropractors',
          },
          {
            required: true,
            value:
              'Colleges, Universities, Professional Schools, and Junior Colleges',
            label:
              'Colleges, Universities, Professional Schools & Junior Colleges',
          },
          {
            required: true,
            value: 'Dentists and Orthodontists',
            label: 'Dentists & Orthodontists',
          },
          {
            required: true,
            value: 'Doctors and Physicians (Not Elsewhere Classified)',
            label: 'Doctors & Physicians',
          },
          {
            required: true,
            value:
              'Medical Services and Health Practitioners (Not Elsewhere Classified)',
            label: 'Medical Services & Health Practitioners',
          },
          {
            required: true,
            value: 'Optometrists and Ophthalmologists',
            label: 'Optometrists & Ophthalmologists',
          },
          {
            required: true,
            value: 'Osteopaths',
            label: 'Osteopaths',
          },
        ],
      },
    ],
  },
  {
    value: 'Education',
    label: 'Education',
    subCategory: [
      {
        value: 'Education_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value:
              'Colleges, Universities, Professional Schools, and Junior Colleges',
            label: 'Colleges, Universities & Professional Schools',
          },
          {
            required: true,
            value:
              'Schools and Educational Services (Not Elsewhere Classified)',
            label:
              'Educational Services & Schools ( Driving/Riding /Martial Arts/Langauage/Others)',
          },
          {
            required: true,
            value: 'Business and Secretarial Schools',
            label: 'Business & Secretarial Schools',
          },
          {
            required: true,
            value: 'Correspondence Schools',
            label: 'Correspondence Schools',
          },
          {
            required: true,
            value: 'Elementary and Secondary Schools',
            label: 'Elementary & Secondary Schools',
          },
          {
            required: true,
            value: 'Vocational and Trade Schools',
            label: 'Vocational & Trade Schools',
          },
        ],
      },
    ],
  },
  {
    value: 'Fashion Accessories',
    label: 'Fashion Accessories',
    subCategory: [
      {
        value: 'Fashion Accessories_CLOTHING STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Miscellaneous Apparel and Accessory Shops',
            label: 'Apparel & Accessory Shops',
          },
          {
            required: true,
            value: 'Wig and Toupee Stores',
            label: 'Wig and Toupee Stores',
          },
          {
            required: true,
            value: 'Women’s Accessory and Specialty Shops',
            label: 'Women’s Accessory & Specialty Shops',
          },
        ],
      },
    ],
  },
  {
    value: 'Financial Services',
    label: 'Financial Services',
    subCategory: [
      {
        value: 'Financial Services_SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value:
              'Financial Institutions – Merchandise, Services, and Debt Repayment',
            label:
              'Financial Institutions – Merchandise, Services, and Debt Repayment',
          },
          {
            required: true,
            value: 'Financial Institutions – Automated Cash Disbursements',
            label: 'Financial Institutions – Automated Cash Disbursements',
          },
          {
            required: true,
            value: 'Financial Institutions – Manual Cash Disbursements',
            label: 'Financial Institutions – Manual Cash Disbursements',
          },
          {
            required: false,
            value: 'Quasi Cash - Customer Financial Institution',
            label: 'Quasi Cash - Customer Financial Institution',
          },
        ],
      },
      {
        value: 'Financial Services_UTILITY SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Money Transfer',
            label: 'Money Transfer',
          },
        ],
      },
    ],
  },
  {
    value: 'Footwear',
    label: 'Footwear',
    subCategory: [
      {
        value: 'Footwear_CLOTHING STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Shoe Stores',
            label: 'Shoe Stores',
          },
        ],
      },
      {
        value: 'Footwear_PERSONAL SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value:
              'Shoe Repair Shops, Shoe Shine Parlors, and Hat Cleaning Shops',
            label: 'Shoe Repair Shops, Shoe Shine Parlors & Hat Cleaning Shops',
          },
        ],
      },
      {
        value: 'Footwear_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Commercial Footwear',
            label: 'Wholesale - Commercial Footwear',
          },
        ],
      },
    ],
  },
  {
    value: 'Fuel Station',
    label: 'Fuel Station',
    subCategory: [
      {
        value: 'Fuel Station_AUTOMOBILES AND VEHICLES',
        merchantCategory: [
          {
            required: true,
            value: 'Automated Fuel Dispensers',
            label: 'Automated Fuel Dispensers',
          },
          {
            required: true,
            value: 'Service Stations (With or without Ancillary Services)',
            label: 'Petrol Pumps',
          },
        ],
      },
      {
        value: 'Fuel Station_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value:
              'Fuel Dealers – Fuel Oil, Wood, Coal, and Liquefied Petroleum',
            label: 'Fuel Dealers – Fuel Oil, Wood, Coal & Liquefied Petroleum',
          },
        ],
      },
      {
        value: 'Fuel Station_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Petroleum and Petroleum Products',
            label: 'Petroleum & Petroleum Products',
          },
        ],
      },
    ],
  },
  {
    value: 'Home And Decor',
    label: 'Home & Decor',
    subCategory: [
      {
        value: 'Home And Decor_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Cigar Stores and Stands',
            label: 'Cigar Stores & Stands',
          },
          {
            required: true,
            value: 'Drapery, Window Covering, and Upholstery Stores',
            label: 'Drapery, Window Covering & Upholstery Stores',
          },
          {
            required: true,
            value:
              'Furniture, Home Furnishings, and Equipment Stores, Except Appliances',
            label:
              'Furniture, Home Furnishings &  Equipment Stores, Except Appliances',
          },
          {
            required: true,
            value: 'Household Appliance Stores',
            label: 'Household Appliance Stores',
          },
          {
            required: true,
            value: 'Miscellaneous Home Furnishing Specialty Stores',
            label: 'Miscellaneous Home Furnishing Specialty Stores',
          },
        ],
      },
      {
        value: 'Home And Decor_RETAIL STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Furniture – Reupholstery, Repair, and Refinishing',
            label: 'Furniture – Reupholstery, Repair & Refinishing',
          },
          {
            required: true,
            value: 'Home Supply Warehouse Stores',
            label: 'Home Supply Warehouse Stores',
          },
          {
            required: true,
            value: 'Mobile Home Dealers',
            label: 'Mobile Home Dealers',
          },
        ],
      },
    ],
  },
  {
    value: 'Hospitals',
    label: 'Hospitals',
    subCategory: [
      {
        value: 'Hospitals_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value: 'Medical and Dental Laboratories',
            label: 'Medical & Dental Labs',
          },
          {
            required: true,
            value: 'Hospitals',
            label: 'Hospitals',
          },
          {
            required: true,
            value: 'Nursing and Personal Care Facilities',
            label: 'Nursing & Personal Care Facilities',
          },
        ],
      },
    ],
  },
  {
    value: 'Hotels',
    label: 'Hotels',
    subCategory: [
      {
        value: 'Hotels_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value:
              'Drinking Places (Alcoholic Beverages) – Bars, Taverns, Nightclubs, Cocktail Lounges, and Discotheques',
            label: 'Bars , Nightclubs & Lounges',
          },
        ],
      },
      {
        value: 'HOTELS AND MOTELS',
        merchantCategory: [
          {
            required: true,
            value:
              'Lodging – Hotels, Motels, Resorts, Central Reservation Services (Not Elsewhere Classified)',
            label: 'Hotels , Motels & Resorts',
          },
        ],
      },
    ],
  },
  {
    value: 'Hyper-Market',
    label: 'Hyper-Market',
    subCategory: [
      {
        value: 'Hyper-Market_RETAIL STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Grocery Stores and Supermarkets',
            label: 'Grocery Stores & Supermarkets',
          },
        ],
      },
    ],
  },
  {
    value: 'Insurance',
    label: 'Insurance',
    subCategory: [
      {
        value: 'Insurance_MAIL ORDER/TELEPHONE ORDER PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Direct Marketing – Insurance Services',
            label: 'Direct Marketing – Insurance Services',
          },
        ],
      },
      {
        value: 'Insurance_SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Insurance Sales, Underwriting, and Premiums',
            label:
              'Insurance Sales, Underwriting , Brokers , Agents & Premiums',
          },
        ],
      },
    ],
  },
  {
    value: 'Mobile And Accessories',
    label: 'Mobile & Accessories',
    subCategory: [
      {
        value: 'Mobile And Accessories_UTILITY SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Telecommunication Equipment and Telephone Sales',
            label: 'Mobile & Telecommunication Equipment',
          },
        ],
      },
    ],
  },
  {
    value: 'Multi Brand -Consumer Durables Electronics',
    label: 'Multi Brand - Consumer Electronics',
    subCategory: [
      {
        value:
          'Multi Brand -Consumer Durables Electronics_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Camera and Photographic Supply Stores',
            label: 'Camera & Photographic Stores',
          },
          {
            required: true,
            value:
              'Computer Maintenance, Repair and Services (Not Elsewhere Classified)',
            label: 'Computer Maintenance, Repairs & Services',
          },
          {
            required: true,
            value: 'Computer Network/Information Services',
            label: 'Computer Network & Information Services',
          },
          {
            required: true,
            value:
              'Computer Programming, Data Processing, and Integrated Systems Design Services',
            label: 'Computer Programming & Data Processing',
          },
          {
            required: true,
            value: 'Computer Software Stores',
            label: 'Computer Software Stores',
          },
          {
            required: true,
            value: 'Digital Goods – Applications (Excludes Games)',
            label: 'Digital Goods – Applications (Excludes Games)',
          },
          {
            required: true,
            value: 'Digital Goods – Games',
            label: 'Digital Goods – Games',
          },
          {
            required: true,
            value: 'Electric Razor Stores – Sales and Service',
            label: 'Electric Razor Stores – Sales & Service',
          },
          {
            required: true,
            value: 'Electrical Parts and Equipment',
            label: 'Electrical Parts & Equipment',
          },
          {
            required: true,
            value: 'Electronics Stores',
            label: 'Electronics Stores',
          },
        ],
      },
      {
        value: 'Multi Brand -Consumer Durables Electronics_REPAIR SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Air Conditioning and Refrigeration Repair Shops',
            label: 'Air Conditioning & Refrigeration Repair Shops',
          },
          {
            required: true,
            value: 'Electrical and Small Appliance Repair Shops',
            label: 'Electrical & Small Appliance Repair Shops',
          },
          {
            required: true,
            value: 'Electronics Repair Shops',
            label: 'Electronics Repair Shops',
          },
        ],
      },
    ],
  },
  {
    value: 'Multi Brand Retail Outlets',
    label: 'Multi Brand Retail Outlets',
    subCategory: [
      {
        value: 'Multi Brand Retail Outlets_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Miscellaneous and Specialty Retail Shops',
            label: 'Miscellaneous & Specialty Retail Shops',
          },
        ],
      },
    ],
  },
  {
    value: 'Opticians',
    label: 'Opticians',
    subCategory: [
      {
        value: 'Opticians_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value: 'Opticians, Optical Goods, and Eyeglasses',
            label: 'Opticians, Optical Goods & Eyeglasses',
          },
        ],
      },
    ],
  },
  {
    value: 'Quick Service Restaurants',
    label: 'Quick Service Restaurants',
    subCategory: [
      {
        value: 'Quick Service Restaurants_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Fast Food Restaurants',
            label: 'Fast Food Restaurants',
          },
        ],
      },
    ],
  },
  {
    value: 'Sports Fitness & Outdoors',
    label: 'Sports Fitness & Outdoors',
    subCategory: [
      {
        value: 'Sports Fitness & Outdoors_AMUSEMENT AND ENTERTAINMENT',
        merchantCategory: [
          {
            required: true,
            value:
              'Commercial Sports, Professional Sports Clubs, Athletic Fields, and Sports Promoters',
            label: 'Commercial Sports, Sports Clubs & Sports Promoters',
          },
        ],
      },
      {
        value: 'Sports Fitness & Outdoors_SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Bicycle Shops – Sales and Service',
            label: 'Bicycle Shops – Sales and Service',
          },
          {
            required: true,
            value: 'Sporting and Recreational Camps',
            label: 'Sporting & Recreational Camps',
          },
          {
            required: true,
            value: 'Swimming Pools – Sales and Service',
            label: 'Swimming Pools – Sales and Service',
          },
          {
            required: true,
            value: 'Trailer Parks and Campgrounds',
            label: 'Trailer Parks and Campgrounds',
          },
          {
            required: true,
            value: 'Photographic Studios',
            label: 'Photographic Studios',
          },
        ],
      },
    ],
  },
  {
    value: 'Sports Footware',
    label: 'Sports',
    subCategory: [
      {
        value: 'Sports Footware _CLOTHING STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Sports Apparel, Riding Apparel Stores',
            label: 'Sports Apparel & Riding Apparel Stores',
          },
        ],
      },
    ],
  },
  {
    value: 'Telecom',
    label: 'Telecom',
    subCategory: [
      {
        value: 'Telecom_UTILITY SERVICES',
        merchantCategory: [
          {
            required: true,
            value:
              'Telecommunication Services, including Local and Long Distance Calls, Credit Card Calls, Calls Through Use of Magnetic- Stripe-Reading Telephones, and Fax Services',
            label: 'Telecommunication Services',
          },
        ],
      },
    ],
  },
  {
    value: 'Toys And Gifts',
    label: 'Toys & Gifts',
    subCategory: [
      {
        value: 'Toys And Gifts_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Gift, Card, Novelty and Souvenir Shops',
            label: 'Gift, Card, Novelty & Souvenir Shops',
          },
          {
            required: true,
            value: 'Hobby, Toy, and Game Shops',
            label: 'Toy & Game Shops',
          },
          {
            required: true,
            value: 'Glassware/Crystal Stores',
            label: 'Glassware & Crystal Stores',
          },
        ],
      },
    ],
  },
  {
    value: 'Travel And Tourism',
    label: 'Travel & Tourism',
    subCategory: [
      {
        value: 'Travel And Tourism_MAIL ORDER/TELEPHONE ORDER PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Direct Marketing – Travel-Related Arrangement Services',
            label: 'Travel Related Services',
          },
        ],
      },
      {
        value: 'Travel And Tourism_TRANSPORTATION SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Boat Rentals and Leasing',
            label: 'Boat Rentals & Leasing',
          },
          {
            required: false,
            value: 'Bus Lines',
            label: 'Bus Lines',
          },
          {
            required: true,
            value: 'Courier Services – Air and Ground, and Freight Forwarders',
            label: 'Courier Services & Freight Forwarders',
          },
          {
            required: true,
            value:
              'Motor Freight Carriers and Trucking – Local and Long Distance, Moving and Storage Companies, and Local Delivery Services',
            label: 'Freight Carriers & Trucking',
          },
          {
            required: true,
            value:
              'Local and Suburban Commuter Passenger Transportation, Including Ferries',
            label: 'Freight Carriers & Trucking',
          },
          {
            required: true,
            value:
              'Local and Suburban Commuter Passenger Transportation, Including Ferries',
            label: 'Local , Suburban Passenger Transportation  & Ferries',
          },
          {
            required: true,
            value: 'Marinas, Marine Service, and Supplies',
            label: 'Marine Services',
          },
          {
            required: true,
            value: 'Passenger Railways',
            label: 'Passenger Railways',
          },
          {
            required: false,
            value: 'Railroads',
            label: 'Railroads',
          },
          {
            required: true,
            value: 'Steamship and Cruise Lines',
            label: 'Steamship & Cruise Lines',
          },
          {
            required: true,
            value: 'Travel Agencies and Tour Operators',
            label: 'Travel Agencies & Tour Operators',
          },
        ],
      },
    ],
  },
  {
    value: 'Other Companies',
    label: 'Miscellaneous',
    subCategory: [
      {
        value: 'Other Companies_AMUSEMENT AND ENTERTAINMENT',
        merchantCategory: [
          {
            required: true,
            value: 'Public Golf Courses',
            label: 'Public Golf Courses',
          },
          {
            required: false,
            value:
              'Betting, including Lottery Tickets, Casino Gaming Chips, Off-Track Betting, and Wagers at Race Tracks',
            label: 'Betting & Casino',
          },
        ],
      },
      {
        value: 'Other Companies_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Sporting Goods Stores',
            label: 'Sporting Goods Stores',
          },
        ],
      },
    ],
  },
  {
    value: 'Jewellery And Gems',
    label: 'Jewellery & Gems',
    subCategory: [
      {
        value: 'Jewellery And Gems_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Jewelry Stores, Watches, Clocks, and Silverware Stores',
            label: 'Jewellery, Watches, Clocks, & Silverware Stores',
          },
        ],
      },
      {
        value: 'Jewellery And Gems_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Precious Stones and Metals, Watches and Jewelry',
            label:
              'Jewellery ,Precious Stones, Gems & Metals Wholesale Distributors',
          },
        ],
      },
    ],
  },
  {
    value: 'Other Organizations',
    label: 'Others',
    subCategory: [
      {
        value: 'MISCELLANEOUS STORE',
        merchantCategory: [
          {
            required: true,
            value: 'Stationery Stores, Office and School Supply Stores',
            label: 'Stationery , Office & School Supply Stores',
          },
          {
            required: true,
            value: 'Book Stores',
            label: 'Book Stores',
          },
        ],
      },
      {
        value: 'Other Organizations_AGRICULTURAL SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Agricultural Co-operatives',
            label: 'Agricultural Co-operatives',
          },
          {
            required: true,
            value: 'Landscaping and Horticultural Services',
            label: 'Landscaping & Horticultural Services',
          },
        ],
      },
      {
        value: 'Other Organizations_AMUSEMENT AND ENTERTAINMENT',
        merchantCategory: [
          {
            required: true,
            value: 'Amusement Parks, Circuses, Carnivals, and Fortune Tellers',
            label: 'Amusement Parks ,Carnivals & Circus',
          },
          {
            required: true,
            value: 'Aquariums, Seaquariums, Dolphinariums, and Zoos',
            label: 'Zoos , Aquariums & Tourist Attractions',
          },
          {
            required: true,
            value:
              'Bands, Orchestras, and Miscellaneous Entertainers (Not Elsewhere Classified)',
            label: 'Bands & Orchestras',
          },
          {
            required: true,
            value: 'Billiard and Pool Establishments',
            label: 'Billiard & Pool Establishments',
          },
          {
            required: true,
            value: 'Bowling Alleys',
            label: 'Bowling Alleys',
          },
          {
            required: true,
            value:
              'Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses',
            label: 'Membership Clubs, Country Clubs & Private Golf Courses',
          },
          {
            required: true,
            value: 'Dance Halls, Studios and Schools',
            label: 'Dance Studios & Schools',
          },
          {
            required: true,
            value: 'Tourist Attractions and Exhibits',
            label: 'Tourist Attractions & Exhibits',
          },
          {
            required: true,
            value: 'Recreation Services (Not Elsewhere Classified)',
            label: 'Recreation Services',
          },
          {
            required: false,
            value: 'Video Amusement Game Supplies',
            label: 'Video Amusement Game Supplies',
          },
          {
            required: true,
            value: 'Video Game Arcades/Establishments',
            label: 'Video Game Parlours',
          },
          {
            required: false,
            value: 'DVD/Video Tape Rental Stores',
            label: 'DVD/Video Tape Rental Stores',
          },
        ],
      },
      {
        value: 'Other Organizations_BUSINESS SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Advertising Services',
            label: 'Advertising Services',
          },
          {
            required: true,
            value: 'Commercial Photography, Art, and Graphics',
            label: 'Commercial Photography, Arts & Graphics',
          },
          {
            required: true,
            value: 'Business Services (Not Elsewhere Classified)',
            label: 'Consulting, Management & Public Relations Services',
          },
          {
            required: true,
            value: 'Cleaning, Maintenance, and Janitorial Services',
            label: 'Cleaning, Maintenance & Janitorial Services',
          },
          {
            required: true,
            value: 'Management, Consulting, and Public Relations Services',
            label: 'Management, Consulting & Public Relations Services',
          },
          {
            required: true,
            value: 'Consumer Credit Reporting Agencies',
            label: 'Consumer Credit Reporting Agencies',
          },
          {
            required: true,
            value:
              'Detective Agencies, Protective Services, and Security Services, including Armored Cars, and Guard Dogs',
            label: 'Security & Detective Agencies',
          },
          {
            required: true,
            value: 'Employment Agencies and Temporary Help Services',
            label: 'Employment Agencies & Temporary Help Services',
          },
          {
            required: true,
            value:
              'Equipment, Tool, Furniture, and Appliance Rental and Leasing',
            label:
              'Equipment, Tool, Furniture, &  Appliance Rental and Leasing',
          },
          {
            required: true,
            value: 'Exterminating and Disinfecting Services',
            label: 'Pest Control & Disinfecting Services',
          },
          {
            required: true,
            value: 'Photofinishing Laboratories and Photo Developing',
            label: 'Photo Developing Services',
          },
          {
            required: true,
            value: 'Quick Copy, Reproduction, and Blueprinting Services',
            label: 'Photocopy & Blueprinting Services',
          },
          {
            required: false,
            value:
              'Computer Programming, Data Processing, and Integrated Systems Design Services',
            label: 'Computer Programming & Data Processing',
          },
          {
            required: false,
            value: 'Stenographic and Secretarial Support',
            label: 'Stenographic and Secretarial Support',
          },
        ],
      },
      {
        value: 'Other Organizations_CONTRACTED SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Carpentry Contractors',
            label: 'U.S. Federal Government Agencies or Departments',
          },
          {
            required: true,
            value: 'General Contractors – Residential and Commercial',
            label: 'Fines',
          },
          {
            required: true,
            value: 'Concrete Work Contractors',
            label: 'Court Costs, Including Alimony and Child Support',
          },
          {
            required: true,
            value: 'Electrical Contractors',
            label: 'Typewriter Stores – Sales, Rentals, and Service',
          },
          {
            required: true,
            value: 'Heating, Plumbing, and Air Conditioning Contractors',
            label: 'News Dealers and Newsstands',
          },
          {
            required: true,
            value:
              'Masonry, Stonework, Tile Setting, Plastering and Insulation Contractors',
            label: 'Antique Reproductions',
          },
          {
            required: true,
            value: 'Miscellaneous Publishing and Printing',
            label: 'Buying and Shopping Services and Clubs',
          },
          {
            required: true,
            value: 'Roofing, Siding, and Sheet Metal Work Contractors',
            label: 'Miscellaneous Personal Services (Not Elsewhere Classified)',
          },
          {
            required: true,
            value: 'Specialty Cleaning, Polishing and Sanitation Preparations',
            label: 'Carpet and Upholstery Cleaning',
          },
          {
            required: true,
            value: 'Special Trade Contractors (Not Elsewhere Classified)',
            label: 'Tax Payments',
          },
          {
            required: true,
            value: 'Typesetting, Plate Making and Related Services',
            label: 'Photographic Studios',
          },
        ],
      },
      {
        value: 'Other Organizations_GOVERNMENT SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Tax Payments',
            label: 'Membership Organizations (Not Elsewhere Classified)',
          },
          {
            required: true,
            value: 'Postal Services – Government Only',
            label: 'Wholesale Clubs',
          },
          {
            required: false,
            value: 'U.S. Federal Government Agencies or Departments',
            label: 'U.S. Federal Government Agencies or Departments',
          },
          {
            required: true,
            value: 'Government Services (Not Elsewhere Classified)',
            label: 'Government Services',
          },
          {
            required: false,
            value: 'Fines',
            label: 'Fines',
          },
          {
            required: false,
            value: 'Court Costs, Including Alimony and Child Support',
            label: 'Court Costs, Including Alimony and Child Support',
          },
          {
            required: true,
            value: 'Bail and Bond Payments',
            label: 'Bail & Bond Payments',
          },
        ],
      },
      {
        value: 'Other Organizations_MAIL ORDER/TELEPHONE ORDER PROVIDERS',
        merchantCategory: [
          {
            required: true,
            value: 'Direct Marketing – Catalog Merchant',
            label: 'Direct Marketing – Catalog Merchant',
          },
          {
            required: true,
            value: 'Direct Marketing – Combination Catalog and Retail Merchant',
            label: 'Direct Marketing – Combination Catalog & Retail Merchant',
          },
          {
            required: true,
            value: 'Direct Marketing – Continuity/Subscription Merchant',
            label: 'Direct Marketing – Continuity/Subscription Merchant',
          },
          {
            required: true,
            value: 'Direct Marketing – Inbound Teleservices Merchant',
            label: 'Direct Marketing – Inbound Teleservices Merchant',
          },
          {
            required: true,
            value:
              'Direct Marketing – Other Direct Marketers (Not Elsewhere Classified)',
            label: 'Direct Marketing – Other Direct Marketers',
          },
          {
            required: true,
            value: 'Direct Marketing – Outbound Telemarketing Merchant',
            label: 'Direct Marketing – Outbound Telemarketing Merchant',
          },
        ],
      },
      {
        value: 'Other Organizations_MISCELLANEOUS STORES',
        merchantCategory: [
          {
            required: true,
            value: 'Wrecking and Salvage Yards',
            label: 'Wrecking & Salvage Yards',
          },
          {
            required: false,
            value: 'Typewriter Stores – Sales, Rentals, and Service',
            label: 'Typewriter Stores – Sales, Rentals, and Service',
          },
          {
            required: true,
            value: 'Tent and Awning Shops',
            label: 'Tent & Awning Shops',
          },
          {
            required: true,
            value: 'Stamp and Coin Stores',
            label: 'Stamp & Coin Stores',
          },
          {
            required: true,
            value: 'Used Merchandise and Secondhand Stores',
            label: 'Used Merchandise & Secondhand Stores',
          },
          {
            required: true,
            value: 'Religious Goods Stores',
            label: 'Religious Goods Stores',
          },
          {
            required: true,
            value: 'Pawn Shops',
            label: 'Pawn Shops',
          },
          {
            required: true,
            value: 'Pet Shops, Pet Foods and Supplies Stores',
            label: 'Pet Shops, Pet Foods, and Supplies',
          },
          {
            required: true,
            value:
              'Direct Marketing – Other Direct Marketers (Not Elsewhere Classified)',
            label: 'Direct Marketing – Other Direct Marketers',
          },
          {
            required: false,
            value: 'News Dealers and Newsstands',
            label: 'News Dealers and Newsstands',
          },
          {
            required: true,
            value: 'Package Stores – Beer, Wine, and Liquor',
            label: 'Package Stores – Beer, Wine & Liquor',
          },
          {
            required: true,
            value: 'Hearing Aids – Sales, Service, and Supply',
            label: 'Hearing Aids – Sales, Service & Supply',
          },
          {
            required: true,
            value: 'Fireplace, Fireplace Screens and Accessories Stores',
            label: 'Fireplace & Accessories Stores',
          },
          {
            required: true,
            value: 'Floor Covering Stores',
            label: 'Floor Covering & Carpet Stores',
          },
          {
            required: true,
            value: 'Florists',
            label: 'Florists',
          },
          {
            required: true,
            value: 'Door-To-Door Sales',
            label: 'Door-To-Door Sales',
          },
          {
            required: true,
            value: 'Sewing, Needlework, Fabric and Piece Goods Stores',
            label: 'Sewing, Needlework, Fabric & Piece Goods Stores',
          },
          {
            required: true,
            value: 'Art Dealers and Galleries',
            label: 'Art Dealers & Galleries',
          },
          {
            required: true,
            value: 'Artist’s Supply and Craft Shops',
            label: 'Handicraft Shops',
          },
          {
            required: false,
            value: 'Antique Reproductions',
            label: 'Antique Reproductions',
          },
          {
            required: true,
            value: 'Antique Shops – Sales, Repairs, and Restoration Services',
            label: 'Antique Shops – Sales, Repairs & Restoration Services',
          },
        ],
      },
      {
        value: 'Other Organizations_PERSONAL SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: false,
            value: 'Buying and Shopping Services and Clubs',
            label: 'Buying and Shopping Services and Clubs',
          },
          {
            required: true,
            value: 'Counseling Services – Debt, Marriage, and Personal',
            label: 'Counseling Services – Debt, Marriage & Personal',
          },
          {
            required: true,
            value: 'Dry Cleaners',
            label: 'Dry Cleaners',
          },
          {
            required: true,
            value: 'Funeral Services and Crematories',
            label: 'Funeral Services & Crematories',
          },
          {
            required: true,
            value: 'Laundries – Family and Commercial',
            label: 'Laundries – Family & Commercial',
          },
          {
            required: false,
            value: 'Miscellaneous Personal Services (Not Elsewhere Classified)',
            label: 'Miscellaneous Personal Services (Not Elsewhere Classified)',
          },
          {
            required: false,
            value: 'Carpet and Upholstery Cleaning',
            label: 'Carpet and Upholstery Cleaning',
          },
          {
            required: false,
            value: 'Tax Payments',
            label: 'Tax Payments',
          },
          {
            required: false,
            value: 'Photographic Studios',
            label: 'Photographic Studios',
          },
        ],
      },
      {
        value:
          'Other Organizations_PROFESSIONAL SERVICES AND MEMBERSHIP ORGANIZATIONS',
        merchantCategory: [
          {
            required: true,
            value: 'Religious Organizations',
            label: 'Religious Organizations',
          },
          {
            required: true,
            value: 'Political Organizations',
            label: 'Political Organizations',
          },
          {
            required: true,
            value: 'Charitable Social Service Organizations',
            label: 'Charitable Social Service Organizations',
          },
          {
            required: false,
            value: 'Membership Organizations (Not Elsewhere Classified)',
            label: 'Membership Organizations (Not Elsewhere Classified)',
          },
          {
            required: true,
            value: 'Legal Services and Attorneys',
            label: 'Legal Services & Attorneys',
          },
          {
            required: true,
            value: 'Child Care Services',
            label: 'Child Care Services',
          },
          {
            required: true,
            value: 'Civic, Social, and Fraternal Associations',
            label: 'Civic, Social & Fraternal Associations',
          },
          {
            required: true,
            value: 'Architectural, Engineering, and Surveying Services',
            label: 'Architectural, Engineering & Surveying Services',
          },
          {
            required: true,
            value: 'Accounting, Auditing, and Bookkeeping Services',
            label: 'Accounting, Auditing & Bookkeeping Services',
          },
        ],
      },
      {
        value: 'Other Organizations_REPAIR SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Tire Retreading and Repair Shops',
            label: 'Tire Retreading & Repair Shops',
          },
          {
            required: true,
            value: 'Miscellaneous Repair Shops and Related Services',
            label: 'Miscellaneous Repair Shops & Related Services',
          },
          {
            required: true,
            value: 'Welding Services',
            label: 'Welding Services',
          },
        ],
      },
      {
        value: 'Other Organizations_RETAIL STORES',
        merchantCategory: [
          {
            required: false,
            value: 'Wholesale Clubs',
            label: 'Wholesale Clubs',
          },
          {
            required: false,
            value: 'Variety Stores',
            label: 'Variety Stores',
          },
          {
            required: true,
            value:
              'Miscellaneous Food Stores – Convenience Stores and Specialty Markets',
            label: 'Convenience Stores',
          },
          {
            required: true,
            value: 'Miscellaneous General Merchandise',
            label: 'General Merchandise',
          },
          {
            required: true,
            value: 'Nurseries and Lawn and Garden Supply Stores',
            label: 'Nurseries and Lawn & Garden Supply Stores',
          },
          {
            required: true,
            value: 'Hardware Stores',
            label: 'Hardware Stores',
          },
          {
            required: true,
            value: 'Glass, Paint, and Wallpaper Stores',
            label: 'Glass, Paint & Wallpaper Stores',
          },
          {
            required: true,
            value: 'Freezer and Locker Meat Provisioners',
            label: 'Freezer & Locker Meat Provisioners',
          },
          {
            required: true,
            value: 'Dairy Products Stores',
            label: 'Dairy Products Stores',
          },
          {
            required: true,
            value: 'Duty Free Stores',
            label: 'Duty Free Stores',
          },
          {
            required: true,
            value: 'Candy, Nut, and Confectionery Stores',
            label: 'Candy, Nut & Confectionery Stores',
          },
          {
            required: true,
            value: 'Discount Stores',
            label: 'Discount Stores',
          },
          {
            required: true,
            value: 'Department Stores',
            label: 'Department Stores',
          },
          {
            required: true,
            value: 'Lumber and Building Materials Stores',
            label: 'Lumber & Building Materials Stores',
          },
        ],
      },
      {
        value: 'Other Organizations_SERVICE PROVIDERS',
        merchantCategory: [
          {
            required: false,
            value:
              'Non-Financial Institutions – Foreign Currency, Non-Fiat Currency (for example: Cryptocurrency), Money Orders (Not Money Transfer), Travelers Cheques, and Debt Repayment',
            label:
              'Non-Financial Institutions-Foreign Currency, Money Orders ,Debt Repayment & Travelers Cheques',
          },
          {
            required: true,
            value: 'Real Estate Agents and Managers – Rentals',
            label: 'Real Estate Agents',
          },
          {
            required: true,
            value: 'Security Brokers/Dealers',
            label: 'Security Brokers/Dealers',
          },
          {
            required: false,
            value: 'Timeshares',
            label: 'Timeshares',
          },
        ],
      },
      {
        value: 'Other Organizations_TRANSPORTATION SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Ambulance Services',
            label: 'Ambulance Services',
          },
          {
            required: true,
            value:
              'Public Warehousing and Storage – Farm Products, Refrigerated Goods, Household Goods, and Storage',
            label: 'Warehousing & Storage - Farm Products & Refrigerated Goods',
          },
          {
            required: true,
            value: 'Tolls and Bridge Fees',
            label: 'Tolls & Bridge Fees',
          },
        ],
      },
      {
        value: 'Other Organizations_UTILITY SERVICES',
        merchantCategory: [
          {
            required: true,
            value:
              'Cable, Satellite and Other Pay Television/Radio/Streaming Services',
            label: 'Cable, Radio & Streaming Services',
          },
          {
            required: false,
            value: 'Computer Network/Information Services',
            label: 'Computer Network/Information Services',
          },
          {
            required: false,
            value: 'Telegraph Services',
            label: 'Telegraph Services',
          },
          {
            required: true,
            value: 'Utilities – Electric, Gas, Water, and Sanitary',
            label: 'Utilities – Electric, Gas, Water & Sanitary',
          },
        ],
      },
      {
        value: 'Other Organizations_WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value:
              'Medical, Dental, Ophthalmic and Hospital Equipment and Supplies',
            label:
              'Medical, Dental, Ophthalmic & Hospital Equipment and Supplies',
          },
          {
            required: true,
            value: 'Stationery, Office Supplies, Printing and Writing Paper',
            label: 'Stationery, Office Supplies, Printing & Writing Paper',
          },
          {
            required: false,
            value: 'Piece Goods, Notions, and Other Dry Goods',
            label: 'Piece Goods, Notions & Other Dry Goods',
          },
          {
            required: true,
            value: 'Plumbing and Heating Equipment and Supplies',
            label: 'Plumbing & Heating Equipment and Supplies',
          },
          {
            required: true,
            value: 'Paints, Varnishes and Supplies......',
            label: 'Paints, Varnishes & Supplies',
          },
          {
            required: true,
            value: 'Photographic, Photocopy, Microfilm Equipment and Supplies',
            label: 'Photographic, Photocopy, Microfilm Equipment & Supplies',
          },
          {
            required: true,
            value: 'Office and Commercial Furniture....',
            label: 'Office and Commercial Furniture',
          },
          {
            required: true,
            value: 'Nondurable Goods (Not Elsewhere Classified)',
            label: 'Nondurable Goods',
          },
          {
            required: true,
            value: 'Metal Service Centers and Offices',
            label: 'Metal Service Centers & Offices',
          },
          {
            required: true,
            value: 'Industrial Supplies (Not Elsewhere Classified)',
            label: 'Industrial Supplies',
          },
          {
            required: true,
            value: 'Hardware, Equipment and Supplies',
            label: 'Hardware, Equipment & Supplies',
          },
          {
            required: true,
            value: 'Florists Supplies, Nursery Stock and Flowers',
            label: 'Florists Supplies, Nursery Stock & Flowers',
          },
          {
            required: true,
            value: 'Durable Goods (Not Elsewhere Classified)',
            label: 'Durable Goods',
          },
          {
            required: true,
            value: 'Construction Materials (Not Elsewhere Classified)',
            label: 'Construction Materials',
          },
          {
            required: true,
            value: 'Commercial Equipment (Not Elsewhere Classified)',
            label: 'Commercial Equipment',
          },
          {
            required: true,
            value: 'Chemicals and Allied Products (Not Elsewhere Classified)',
            label: 'Chemicals & Allied Products',
          },
        ],
      },
      {
        value: 'PERSONAL SERVICE PROVIDER',
        merchantCategory: [
          {
            required: true,
            value: 'Dating Services',
            label: 'Dating Services',
          },
        ],
      },
      {
        value: 'REPAIR SERVICE',
        merchantCategory: [
          {
            required: true,
            value: 'Towing Services',
            label: 'Towing Services',
          },
        ],
      },
      {
        value: 'WHOLESALE DISTRIBUTORS AND MANUFACTURER',
        merchantCategory: [
          {
            required: true,
            value: 'Information Retrieval Services',
            label: 'Information Retrieval Services',
          },
        ],
      },
    ],
  },
  {
    value: 'Watches',
    label: 'Watch',
    subCategory: [
      {
        value: 'WHOLESALE DISTRIBUTORS AND MANUFACTURERS',
        merchantCategory: [
          {
            required: true,
            value: 'Information Retrieval Services',
            label: 'Watch - Wholesale Distributors & Manufacturers',
          },
        ],
      },
      {
        value: 'Watches_REPAIR SERVICES',
        merchantCategory: [
          {
            required: true,
            value: 'Watch, Clock and Jewelry Repair',
            label: 'Watch, Clock & Jewelry Repair',
          },
        ],
      },
    ],
  },
];
